import React from "react";
import ReportSelectorDropdown from "./report.selector.dropdown";
import ReportChartSelector from "./report.chart.selector";
import {ReportChartComponent} from "../types/report.chart.component";
import {useAppStore} from "../../../common/app.store.consumer";
import {ChartTypes} from "../types/report.chart.types";
import ReportChartSpiderWeb from "./report.chart.spiderweb";
import ReportChartBar from "./report.chart.bar";

type Props = ReportChartComponent & {isPdf?: boolean};

const ReportSelectorAndChartPanel: React.FC<Props> = useAppStore()((props: Props) => {
	const reportPageStore = props.appStore.reportPageStore;
	const userStore = props.appStore.userStore;
	return (
		<div className="cih-chart-area cih-flex cih-flex-col">
			<div className="cih-flex">
				{userStore.isMember && reportPageStore.userQuestionnaireAnswerSheets.length > 1 && <ReportSelectorDropdown />}
				<ReportChartSelector />
			</div>
			<div className="cih-chart">
				{reportPageStore.reportChartType === ChartTypes.BarChart && !props.isPdf && <ReportChartBar />}
				{(reportPageStore.reportChartType === ChartTypes.SpiderWebChart || props.isPdf) && <ReportChartSpiderWeb isPdf={props.isPdf} />}
			</div>
		</div>
	);
});

export default ReportSelectorAndChartPanel;
